import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();

    return object().shape({
        name: string().required(REQUIRED_TEXT).nullable(),
        description: string().required(REQUIRED_TEXT).nullable(),
    });
};
